import { useContext, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import FormErrors from '../../components/FormErrors';
import { Navigate } from 'react-router-dom';
import { verifyEmail } from '../../lib/allauth';
import { AuthContext } from '../../auth/AuthContext';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseTextField from '../../components/BaseTextField';
import BaseFormContainer from '../../components/BaseFormContainer';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});

export default function VerifyEmailByCode() {
  const { refreshAuth } = useContext(AuthContext);
  const [code, setCode] = useState('');
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    verifyEmail(code)
      .then(async (content) => {
        setResponse((r) => ({ ...r, content }));
        if ([200, 401].includes(content?.status)) {
          await refreshAuth();
        }
      })
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .finally(() => setResponse((r) => ({ ...r, fetching: false })));
  }

  if ([200, 401].includes(response.content?.status)) {
    return <Navigate to='/account/email' />;
  }

  return (
    <BackgroundContainer>
      <BaseFormContainer>
        <BaseHeader sx={{ fontSize: '2rem' }}>Verify Your Email</BaseHeader>
        <Subtitle sx={{
          marginBottom: '20px',
          fontSize: '1.2rem',
          '@media (max-width: 400px)': { fontSize: '1.1rem' },
          '@media (max-width: 360px)': { fontSize: '1rem' },
          '@media (max-width: 320px)': { fontSize: '0.95rem' },
        }}>
          Enter the verification code sent to your email.
        </Subtitle>
        <FormErrors errors={response.content?.errors} />
        <BaseTextField
          label="Verification Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          type="text"
          required
        />
        <FormErrors param="key" errors={response.content?.errors} />
        <BaseButton disabled={response.fetching} onClick={submit}>
          Verify
        </BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>
  );
}
